import React, { RefAttributes } from 'react';

import { cn, ClassName, ComponentWrapperProps } from '../../utils';
import styles from './index.module.scss';


type Ellipsis = {
    ellipsis?: boolean;
};

const applyEllipsis = (ellipsis?: boolean) => ({
    [styles.ellipsis]: ellipsis,
});

export type HeadingProps = Ellipsis & {
    headingType: 'h1Modal' | 'h1Element' | 'h1Title' | 'h2' | 'h3';
};

export const Heading = <PComponent extends ClassName>({
    component, componentRef,
    headingType, ellipsis, // HeadingProps
    className, ...props // PComponent
}: ComponentWrapperProps<PComponent, HeadingProps>) =>
    React.createElement(component, {
        ...props,
        ref: componentRef,
        className: cn(
            styles.heading,
            styles[headingType],
            applyEllipsis(ellipsis),
            className,
        ),
    } as unknown as PComponent & RefAttributes<any>);


export type TextProps = Ellipsis & {
    textType?: (
        'regular' |
        'light' |
        'bold' |
        'bolder' |
        'info' |
        'budget' |
        'date' |
        'link'
    );
    textCompact?: boolean;
};

export const Text = <PComponent extends ClassName>({
    component, componentRef,
    textType = 'regular', textCompact, ellipsis, // TextProps
    className, ...props // PComponent
}: ComponentWrapperProps<PComponent, TextProps>) =>
    React.createElement(component, {
        ...props,
        ref: componentRef,
        className: cn(
            styles.text,
            styles[textType], {
                [styles.compact]: textCompact,
            },
            applyEllipsis(ellipsis),
            className,
        ),
    } as unknown as PComponent & RefAttributes<any>);

export type MenuProps = {
    current?: boolean;
};

export const Menu = <PComponent extends ClassName>({
    component, componentRef,
    current, // MenuProps
    className, ...props // PComponent
}: ComponentWrapperProps<PComponent, MenuProps>) =>
    React.createElement(component, {
        ...props,
        ref: componentRef,
        className: cn(
            styles.text,
            styles.ellipsis,
            styles.menu, {
                [styles.current]: current,
            },
            className,
        ),
    } as unknown as PComponent & RefAttributes<any>);
